import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../../../components/Buttons/Button";
import CustomModal from "../../../../components/Modal/CustomModal";

const Close = ({ onClick, isOpen, onRequestClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="디지털상담 상담원 채팅 종료"
    >
      <p className="text-2xl font-semibold text-center mb-11">
        디지털 상담을 <br />
        종료 하시겠습니까?
      </p>
      <div className="flex w-full gap-2">
        <form method="dialog" className="w-full">
          <Button
            size="sm"
            cancle
            onClick={() => {
              navigate("/chat/agent");
              onRequestClose();
            }}
          >
            취소
          </Button>
        </form>
        <Button size="sm" onClick={onClick}>
          확인
        </Button>
      </div>
    </CustomModal>
  );
};

export default Close;
